module.exports = __webpack_public_path__ + "static/media/catcher.c9be20de.jpg";